// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4_YSq","left":"styles_left__2g2DP","desktopActions":"styles_desktopActions__3dG2k","title":"styles_title__1SJuf"};